<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App',
        metaInfo() {
            return {
                title: this.$t('meta.global.title'),
                titleTemplate: '%s | ' + window.location.hostname,
                meta: [
                    { vmid: 'robots', name: 'robots', content: 'noindex' },
                    { vmid: 'description', name: 'description', content: this.$t('meta.global.description') },
                ]
            }
        },
        created() {
            this.getTokenFromLocalStorage()

            if (localStorage.getItem('userSave') === 'false') {
                this.$store.commit('LOGOUT_TIMER')
            }
        },
        methods: {
            getTokenFromLocalStorage() {
                if (localStorage.getItem('userToken')) {
                    let value = {
                        save: localStorage.getItem('userSave'),
                        roles: localStorage.getItem('roles'),
                        tokens: {
                            token: localStorage.getItem('userToken'),
                            refreshToken: localStorage.getItem('refreshToken')
                        }
                    }
                    this.$store.commit('TOKENS', value)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue